import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { topSlice } from "src/pages/Top/topSlice";
import { feePatternsSlice } from "src/common/feePatterns/feePatternsSlice";

const rootReducer = combineReducers({
  top: topSlice.reducer,
  feePatterns: feePatternsSlice.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // シリアライズエラーが出るので暫定対応
        ignoredActions: ["topSlice/setProduct"],
        ignoredPaths: ["top.product"],
      },
    }),
});
